// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".footer {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  padding: 20px 20px 0 20px;\n  margin: 0 -20px;\n  border-top: 3px solid var(--primary-background-color);\n}\n.footer div button:last-child {\n  margin-left: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
